export const STATUS_LABELS: Record<string, string> = {
  not_started: "未开始",
  learning: "学习中",
  provisional: "暂定掌握",
  mastered: "已掌握",
};

export const DIMENSION_LABELS: Record<string, string> = {
  recall: "回忆",
  near_transfer: "近迁移",
  far_transfer: "远迁移",
  performance: "实操",
};

export function formatDate(value?: string | null, full = false): string {
  if (!value) return "--";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    ...(full ? { year: "numeric" } : {}),
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
}

export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (!hours) return `${remainder} 分钟`;
  return remainder ? `${hours} 小时 ${remainder} 分` : `${hours} 小时`;
}

export function formatSize(bytes: number | null): string {
  if (bytes == null) return "";
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
}

export function overdue(value: string): string {
  const delta = Date.now() - new Date(value).getTime();
  const days = Math.floor(delta / 86_400_000);
  if (days >= 1) return `逾期 ${days} 天`;
  return `逾期 ${Math.max(1, Math.floor(delta / 3_600_000))} 小时`;
}
